let islgdAddress = {
  personalCenterUrl:'https://mdata.pharmacodia.com/personalCenter/#',
  api:'https://mdata.pharmacodia.com/',//
  iconUrl:'https://cdn.pharmacodia.com/data/pharmnews/icon/'
}
export {islgdAddress};



// WEBPACK FOOTER //
// ./src/common/config.js